module.exports = require('./helpers/bundle-url').getBundleURL('8g68e') + "graduation_requirements.3e643f97.png";